package com.shadowings.gero.domain.model

// analyticsKey is a stable English key logged to Firebase Analytics; it must never change even
// if the localized option label does, since it's the value analytics dashboards group by.
enum class FeaturePollOption(val analyticsKey: String) {
    NewChapters("new_chapters"),
    NewQuizModes("new_quiz_modes"),
    ReviewSection("review_section"),
    CharacterAccessories("character_accessories");

    companion object {
        // Identifies this poll's current content in UserData.answeredFeaturePolls. Bump this
        // (e.g. to "feature_request_v2") whenever the options above change, so the poll
        // resurfaces for everyone instead of staying permanently answered under a stale key.
        const val POLL_KEY = "feature_request_v1"
    }
}
